export var COLUMN_GAP = '32px';
export var RIGHT_COLUMN_WIDTH_DESKTOP = '328px';
export var LEFT_COLUMN_WIDTH_DESKTOP = "calc(100% - ".concat(RIGHT_COLUMN_WIDTH_DESKTOP, " - ").concat(COLUMN_GAP, ")");
export var RIGHT_COLUMN_WIDTH_TABLET = '249px';
export var LEFT_COLUMN_WIDTH_TABLET = '455px';